//#region src/lib/sentry/sentryReplayPrivacyMask.ts
var e = "data-sentry-mask", t = Object.freeze({ [e]: "" }), n = /* @__PURE__ */ new Set([
	"chat",
	"comment-detail",
	"comments-list",
	"users"
]), r = (e) => n.has(e);
//#endregion
export { n as PANEL_KEYS_WITH_PERSONAL_DATA, e as SENTRY_REPLAY_MASK_ATTRIBUTE, r as panelHasPersonalData, t as sentryReplayMaskProps };
